import { pickT } from "@repo/shared";
import { T } from "./component-defaults.i18n";

export function getComponentDefault(
  lang: string,
  componentType: string,
): { title: string; description: string } | null {
  const langDefaults = pickT(T, lang);
  return langDefaults[componentType] || null;
}
